import {ReactNode} from "react";
import baseTheme from "./baseTheme";
import ExtendTheme from "./ExtendTheme";

export default function RootTheme({children}: {children?: ReactNode}) {
  return <ExtendTheme extension={baseTheme}>{children}</ExtendTheme>;
}
